/**
 * TanStack Router: /performance/objetivos-individuais
 *
 * Component: ObjetivosIndividuaisPage
 * Layout: Authenticated (_auth)
 */
import { createFileRoute } from '@tanstack/react-router'
import ObjetivosIndividuaisPage from '@/app/performance/objetivos-individuais/page'

/**
 * Route: /performance/objetivos-individuais
 * Layout: _auth (authenticated)
 * Component: ObjetivosIndividuaisPage
 */
export const Route = createFileRoute('/_auth/performance/objetivos-individuais/')({
  component: ObjetivosIndividuaisPage,
})
